import React from "react";

const Footer = () => (
  <footer className="bg-light p-6 text-center">
    
  </footer>
);

export default Footer;
